import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./parametros.service";
const url = environment.ruta;
export class AdministradorService {
    constructor(_http, _valor) {
        this._http = _http;
        this._valor = _valor;
    }
    // ============================================================================================
    // Inicio Dashboard
    obtenerDashoboard(ejercicio) {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}administrar/dashboard?ejercicio=${ejercicio}`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    obtenerReportes(info) {
        let encabezado = this._valor.postToken();
        return this._http.post(`${url}Administrar/Reportes`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    accionCambioProceso(estatus) {
        let encabezado = this._valor.getToken();
        return this._http.put(`${url}administrar/dashboard/proceso/${estatus}`, '', { headers: encabezado }).pipe(map(this.infoDatos));
    }
    // Final
    // ============================================================================================
    // ============================================================================================
    // Inicio Usuarios
    obtenerUsusarios() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}administrar/catalogos/usuarios`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    obtenerUsusariosNuevos() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}administrar/catalogos/usuariosNuevos`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    agregarNuevoUsuario(info) {
        let encabezado = this._valor.getToken();
        return this._http.post(`${url}Administrar/usuarios`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    ModificarUsuario(info) {
        let encabezado = this._valor.getToken();
        return this._http.put(`${url}Administrar/usuarios`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    obtenerCorreos(idUsuario) {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}administrar/Catalogos/CorreosAdicionales/${idUsuario}`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    accionCorreoNuevo(info) {
        let encabezado = this._valor.getToken();
        return this._http.post(`${url}Administrar/CorreosAdicionales/`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    accionCorreoEliminar(idUsuarioCorreo) {
        let encabezado = this._valor.getToken();
        return this._http.delete(`${url}Administrar/CorreosAdicionales/${idUsuarioCorreo}`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    // Accion para eleiminar correos adicionales Verificar si se utiliza
    // async accionUsuarioEliminar(idUsuario: number) {
    //   let result: any = await this._http.delete(`${url}Administrar/usuarios/${idUsuario}`, { headers: this.encabezado }).pipe(map(this.infoDatos));
    //   return result;
    // }
    // Fin Usuarios
    // ============================================================================================
    // ============================================================================================
    // Inicio Organos
    obtenerCatalagosOrganos() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}administrar/Catalogos/organos`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    obtenerCatalagosOrganosNuevos() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}administrar/catalogos/organosNuevos`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    accionCambioEstatus(info) {
        let encabezado = this._valor.getToken();
        return this._http.put(`${url}administrar/organos`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    accionAgregarOrgano(info) {
        let encabezado = this._valor.getToken();
        return this._http.post(`${url}administrar/organos`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    // Fin Organos
    // ============================================================================================
    obtenerTiposImprocedencia() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}Administrar/Catalogos/TiposImprocedencias/`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    guardarImprocedencia(info) {
        let encabezado = this._valor.getToken();
        return this._http.post(`${url}Administrar/Improcedencias/`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    actualizarImprocedencia(info) {
        let encabezado = this._valor.getToken();
        return this._http.put(`${url}Administrar/Improcedencias/`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    eliminarImprocedencia(info) {
        let encabezado = this._valor.getToken();
        return this._http.delete(`${url}Administrar/Improcedencias/${info}`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    // Tipos de Prevenciones
    obtenerTiposPrevenciones() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}Administrar/Catalogos/TiposPrevenciones/`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    guardarPrevencion(info) {
        let encabezado = this._valor.getToken();
        return this._http.post(`${url}Administrar/Prevenciones/`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    actualizarPrevencion(info) {
        let encabezado = this._valor.getToken();
        return this._http.put(`${url}Administrar/Prevenciones/`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    eliminarPrevencion(info) {
        let encabezado = this._valor.getToken();
        return this._http.delete(`${url}Administrar/Prevenciones/${info}`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    // Articulos
    obtenerArticulos() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}Catalogos/Articulos/`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    obtenerArticulosAdmin() {
        let encabezado = this._valor.getToken();
        return this._http.get(`${url}Administrar/Catalogos/Articulos/`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    guardarArticulo(info) {
        let encabezado = this._valor.getToken();
        return this._http.post(`${url}Administrar/Articulos/`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    actualizarArticulo(info) {
        let encabezado = this._valor.getToken();
        return this._http.put(`${url}Administrar/Articulos/`, info, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    eliminarArticulo(info) {
        let encabezado = this._valor.getToken();
        return this._http.delete(`${url}Administrar/Articulos/${info}`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    // obtenerReportes
    infoDatos(res) {
        let body = res;
        return body.info || {};
    }
}
AdministradorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdministradorService_Factory() { return new AdministradorService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ParametrosService)); }, token: AdministradorService, providedIn: "root" });
